import React from 'react';
import { View } from 'src/components/basic';

import { HeaderBack } from 'src/components/mobile/HeaderBack';
import LANG_CONST from 'src/helpers/lang/const';
import { AllCategories } from 'src/components/mobile/Categories';

import doctorsModel from '../doctorsModel';
import { remCss } from 'src/components/mobile/utils';

export const Categories = ({ clinic, onBack }) => {
  return (
    <View
      style={{
        height: '100%',
        backgroundColor: 'white'
      }}
    >
      <HeaderBack onBack={onBack} title={LANG_CONST.titles.all_categories} />
      <View
        style={{
          paddingBottom: remCss(15),
          overflow: 'auto',
          flex: 1
        }}
      >
        <AllCategories
          specialist={clinic.doctorsSpecialist}
          onClick={(s) => {
            doctorsModel.onChangeSpecialist(s);
            onBack();
          }}
        />
      </View>
    </View>
  );
};
